module.exports = __webpack_public_path__ + "static/media/1.3ca0e9be.png";